module.exports = __webpack_public_path__ + "static/media/cinema.3c7956d2.jpg";